exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button{background-color:#4caf50;border:none;color:#fff;padding:10px 24px;text-align:center;text-decoration:none;display:inline-block;font-size:15px;margin:10px}.button .red{background-color:red}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/components/Quiz/styles.css
 ** module id = 1186
 ** module chunks = 0
 **/